interface Params {
  onError?: () => void;
  url: string;
}

const waitForAudio = ({ onError, url }: Params) => {
  return new Promise((resolve) => {
    const audio = document.createElement('audio');
    let errors = 0;
    audio.onloadedmetadata = () => {
      resolve(true);
    };
    audio.onerror = () => {
      if (onError) onError();
      if (errors > 100) resolve(false);
      errors++;
      setTimeout(() => {
        audio.src = url;
      }, 5000);
    };
    audio.src = url;
  });
};

export default waitForAudio;
